// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__261i1","header":"PatientBlock_header__YvggD","label":"PatientBlock_label__1gRVt","option":"PatientBlock_option__3Umxn"};